import { BackButton, MainButton, UserLevelProgress, View } from "@ds"
import { FlipScore, Lines, MainLayout } from "@shared"
import { Border } from "../battlePass/components/Border"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import styles from "./leaderboard.module.scss"
import { Leaderboard as LeaderboardTable } from "./components/Leaderboard"
import { Divider } from "../shop/Divider"
export const Leaderboard = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()
  
    return <MainLayout showInventory={false} isNavbarFadeble>
    {(scrollRef) => (
      <>
        <BackButton onClick={() => navigate('/')} />
        <MainButton hidden />
        <View fadeIn className={styles.view} ref={scrollRef}>
          <div className={styles.container}>
            <Border className={styles.leftBorder} />
            <Border className={styles.rightBorder} />
            <div className={styles.header}>
              <Lines className={styles.lines} />
              <div className={styles.title}>{t('leaderboard.title')}</div>
              <UserLevelProgress className={styles.userLevel} />
            </div>
            <div>
                <div className={styles.description}>{t('leaderboard.description')}</div>
                <div className={styles.flipScore}><FlipScore /></div>
                <Divider reverse />
                <LeaderboardTable />
            </div>
          </div>
        </View>
      </>
    )}
  </MainLayout>
}